import request from '@/utils/request'
const apiPath = '/tech/eduStats/tee'

/**
 * 教培数据统计（REQ-2026-125349）
 * 三张报表 + 三个导出；数据范围由后端按登录身份决定
 */
const eduStatsApi = {
  // 当前登录账号的数据范围（总监/总部=全量，督导=名下老师，老师=本人）
  getScope() {
    return request.get(`${apiPath}/scope`)
  },
  // 技术老师签到与出货
  teacherList(query) {
    return request.get(`${apiPath}/teacherList`, { params: query })
  },
  exportTeacher(query) {
    return request.get(`${apiPath}/exportTeacher`, { params: query })
  },
  // 客户数据明细
  customerList(query) {
    return request.get(`${apiPath}/customerList`, { params: query })
  },
  exportCustomer(query) {
    return request.get(`${apiPath}/exportCustomer`, { params: query })
  },
  // 新加盟客户年度进货
  newCustomerList(query) {
    return request.get(`${apiPath}/newCustomerList`, { params: query })
  },
  exportNewCustomer(query) {
    return request.get(`${apiPath}/exportNewCustomer`, { params: query })
  }
}
export default eduStatsApi
